module.exports = __webpack_public_path__ + "images/alert-bell-7e62afe0.svg";